import React, {useRef} from 'react';
import Countdown from 'react-countdown';

const Timer = ({mainTime}) => {
    const countdown = useRef(null);

    const doubleNumber = (val) => {
        if (val.toString().length < 2) {
            return `0${val}`
        }
        return val;
    }

    const renderer = ({ days, hours, minutes, seconds }) => {
        return (
            <p className="text-white text-center fs18 font-normal mt5">{doubleNumber(days)}:{doubleNumber(hours)}:{doubleNumber(minutes)}:{doubleNumber(seconds)}</p>
        );
    }

    if (mainTime && mainTime !== 0) {
        return (
            <Countdown
                ref={countdown}
                date={mainTime}
                renderer={renderer}
                intervalDelay={0}
                autoStart={true}
            />
        )
    } else {
        return null
    }
};

export default Timer;
